module.exports = __webpack_public_path__ + "img/article-image-1.927b75c2.webp";